import { CashTypeEnum } from "@/model/data/enums/CashTypeEnum";

export class ModelInfo {

    modelName: string = null;
    rollMaxItems: number = -1;
    bagMaxItems: number = -1;
    rollNumber: number = -1;
    hasBag: boolean = false;
    cashType: CashTypeEnum = CashTypeEnum.Unknown;

    constructor() { }

    public parse(obj: any) {

        if (obj.ModelName)
            this.modelName = obj.ModelName;

        if (obj.RollMaxItems)
            this.rollMaxItems = obj.RollMaxItems;
        if (obj.BagMaxItems)
            this.bagMaxItems = obj.BagMaxItems;
        if (obj.RollNumber)
            this.rollNumber = obj.RollNumber;
        if (obj.HasBag != null)
            this.hasBag = obj.HasBag;

        if (obj.CashType != null && Object.values(CashTypeEnum).includes(obj.CashType)) this.cashType = obj.CashType;

    }

}